<app-enfaf-modal
  [title]="!editMode ? 'Nuevo Embajador' : 'Editar Embajador'"
  (onConfirm)="saveAmbassador()"
  (onClose)="confirmCloseModal()"
  [disableConfirmButton]="ambassadorForm.invalid || isSavingAmbassador"
  [isLoading]="isSavingAmbassador"
  svgIcon="user-money-dark"
>
  @if (!!ambassadorForm) {
    <form [formGroup]="ambassadorForm" autocomplete="off" class="container">
      <!-- Basic Information Section -->
      <!-- Ambassador Type -->
      <div class="custom-row">
        <simple-autocomplete-light
          #multiAutocomplete
          [disabled]="editMode"
          [label]="'Email'"
          [placeholder]="'Buscar'"
          [fetchData]="fetchStudents"
          [control]="ambassadorEmailControl"
          [selectedOption]="selectedStudentOption"
          (selectedChanged)="handleSelectStudent($event)"
          [errorLabel]="'El email es requerido y debe ser válido'"
        />

        <enfaf-select-light
          [control]="ambassadorForm.get('type')!"
          [options]="ambassadorTypeOptions"
          label="Tipo de Embajador"
          errorLabel="El tipo de embajador es requerido"
        />
      </div>

      <div class="custom-row">
        <enfaf-input
          [control]="ambassadorForm.get('name')!"
          label="Nombre"
          placeholder="Nombre del embajador"
          errorLabel="El nombre es requerido"
          color="light"
        />
        <enfaf-input
          [control]="ambassadorForm.get('lastname')!"
          label="Apellidos"
          placeholder="Apellidos del embajador"
          errorLabel="Los apellidos son requeridos"
          color="light"
        />
      </div>

      <!-- Alias + Phone -->
      <div class="custom-row">
        <enfaf-input
          [control]="ambassadorForm.get('alias')!"
          label="Alias"
          placeholder="Ej: MIK3YMX2A9"
          errorLabel="El alias es requerido (máx. 50 caracteres)"
          color="light"
        />
        <div class="phone-field-wrapper">
          <enfaf-input [control]="ambassadorForm.get('phonePrefix')!" label="Prefijo" placeholder="+34" color="light" class="phone-prefix-input" />
          <enfaf-input
            [control]="ambassadorForm.get('phone')!"
            label="Teléfono"
            placeholder="612345678"
            errorLabel="Debe tener exactamente 9 dígitos"
            color="light"
            class="phone-input"
          />
        </div>
      </div>

      <!-- Ambassador Program Enabled -->
      <div class="commissions-header">
        <span class="commision-program-switch">
          <app-enfaf-switch-dark [control]="ambassadorForm.controls.isAmbassadorProgramEnabled" label="" color="light" />
          Activar programa embajadores
        </span>
        <app-enfaf-button type="modal-outline" (onClick)="resetCommissionForm()">Añadir comisión específica por curso</app-enfaf-button>
      </div>

      <div class="commision-section">
        @if (isCommissionFormEnabled) {
          <div class="commission-form">
            <simple-autocomplete-light
              [class.with-padding]="isCommissionCourseSelected"
              [required]="true"
              [label]="'Seleccionar curso'"
              [placeholder]="'Buscar'"
              [fetchData]="fetchCourses"
              [disableOptions]="disabledCourseOptions"
              [selectedOption]="selectedCourseOption"
              (selectedChanged)="handleSelectCourse($event)"
            />

            @if (isCommissionCourseSelected) {
              <div class="custom-row">
                <enfaf-select-light
                  [control]="commissionForm.get('commissionType')!"
                  [options]="commissionTypeOptions"
                  label="Tipo"
                  errorLabel="Selecciona el tipo"
                />

                <enfaf-input
                  [control]="commissionForm.get('commissionValue')!"
                  [iconSuffix]="getCommissionIcon(commissionForm)"
                  label="Valor"
                  type="number"
                  [errorLabel]="getCommissionValueError(commissionForm)"
                  (blur)="validateCommissionValue(commissionForm)"
                  color="light"
                />
              </div>
              <div class="commission-form__actions">
                <app-enfaf-icon [isButton]="true" svgIconName="check-green" [isDisabled]="commissionForm.invalid" (onClick)="submitCommisionForm()" />
                <app-enfaf-icon svgIconName="x-red" [isButton]="true" svgIconName="x-red" (onClick)="closeCommissionForm()" />
              </div>
            }
          </div>
        }

        <!-- Course Commissions Form -->
        @if (courseCommissionsControls.length > 0) {
          <div class="commision-table-wrapper">
            <table class="commissions-table">
              <thead>
                <tr>
                  <th class="sortable" [class.sorted]="isCommissionSorted('courseName')" (click)="onSortCommissions('courseName')">
                    <div> Curso <app-enfaf-icon [svgIconName]="getCommissionSortIcon('courseName')" /> </div>
                  </th>
                  <th class="sortable" [class.sorted]="isCommissionSorted('commissionType')" (click)="onSortCommissions('commissionType')">
                    <div> Tipo Comisión <app-enfaf-icon [svgIconName]="getCommissionSortIcon('commissionType')" /> </div>
                  </th>
                  <th class="center sortable" [class.sorted]="isCommissionSorted('commissionValue')" (click)="onSortCommissions('commissionValue')">
                    <div>Comisión <app-enfaf-icon [svgIconName]="getCommissionSortIcon('commissionValue')" /></div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (commissionGroup of courseCommissionsControls; track $index) {
                  <tr class="commission-row">
                    <td class="course-name">{{ commissionGroup.controls.courseName.value }}</td>
                    <td class="commission-type">{{ getCommisionTypeDisplayName(commissionGroup.controls.commissionType.value) }}</td>
                    <td class="commission-value center">
                      {{ commissionGroup.controls.commissionValue.value
                      }}{{ commissionGroup.controls.commissionType.value === 'percentage' ? '%' : '€' }}
                    </td>
                    <td class="actions-cell">
                      <div class="actions-container">
                        <!-- Menu Button -->
                        <button type="button" mat-icon-button class="action-button" [matMenuTriggerFor]="ambassadorOptions" matTooltip="Opciones">
                          <app-enfaf-icon svgIconName="more-horizontal-dark" iconSize="21px" />
                        </button>

                        <!-- Menu Options -->
                        <mat-menu #ambassadorOptions="matMenu">
                          <button mat-menu-item (click)="resetCommissionForm(commissionGroup.value)">
                            <span>Editar</span>
                          </button>
                          <button mat-menu-item color="warn" (click)="removeCommission($index)">
                            <span>Borrar</span>
                          </button>
                        </mat-menu>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </form>
  }
</app-enfaf-modal>
